module.exports = __webpack_public_path__ + "media/images/story/typo/congratsNormal-8600e55456df7e7cc5f4577f0e4cfc9e.svg";